module.exports = __webpack_public_path__ + "img/1 (112).91ca10e8.png";